import { DICOM_COLLECTIONS, DICOM_INTERFACE_TYPES } from './Dicom/dicom.config';
import { WORKLIST_COLLECTIONS, WORKLIST_INTERFACE_TYPES } from './Worklist/worklist.config';
import { RIS_COLLECTIONS, RIS_INTERFACE_TYPES } from './Ris/ris.config';
export { FIELD_TYPES, serializeFieldValue, isFieldVisible } from './Interfaces.shared';

export const INTERFACE_TYPES = {
  ...DICOM_INTERFACE_TYPES,
  ...WORKLIST_INTERFACE_TYPES,
  ...RIS_INTERFACE_TYPES,
};

export const INTERFACE_MODULES = {
  dicom: {
    id: 'dicom',
    titleKey: 'Settings.dicom_interfaces',
    collections: DICOM_COLLECTIONS,
  },
  worklist: {
    id: 'worklist',
    titleKey: 'Settings.worklist_interfaces',
    collections: WORKLIST_COLLECTIONS,
  },
  ris: {
    id: 'ris',
    titleKey: 'Settings.ris_interfaces',
    collections: RIS_COLLECTIONS,
  },
};

export const getInterfaceTypeConfig = (typeId) => INTERFACE_TYPES[typeId] || null;

export const getCollectionConfig = (moduleId, collectionId) => {
  const module = INTERFACE_MODULES[moduleId];
  if (!module) return null;
  return module.collections.find((collection) => collection.id === collectionId) || null;
};

// kept for callers that still pass a concrete type id.
export const getModuleConfig = (moduleId, id) => {
  return getInterfaceTypeConfig(id) || getCollectionConfig(moduleId, id);
};

export const getSubmodules = (moduleId) => {
  const module = INTERFACE_MODULES[moduleId];
  return module?.collections || [];
};

export const getAllModules = () => Object.values(INTERFACE_MODULES);
